import React from 'react';
import { Link } from 'react-router-dom';
import { Scale, Mail, Phone } from 'lucide-react';

export default function TermsPage() {
    return (
        <main className="main">
            {/* Hero Section */}
            <section className="hero" style={{
                minHeight: '300px',
                background: 'linear-gradient(193deg, rgb(242, 255, 168) 0%, rgb(255, 154, 255) 100%)'
            }}>
                <div className="container" style={{ textAlign: 'center' }}>
                    <Scale size={64} style={{ color: 'var(--primary)', marginBottom: '24px' }} />
                    <h1 style={{ fontSize: '48px', marginBottom: '24px' }}>Terms and Conditions</h1>
                    <p style={{
                        fontSize: '14px',
                        marginTop: '16px',
                        color: 'var(--text-secondary)'
                    }}>
                        Last Updated: December 29, 2025
                    </p>
                </div>
            </section>

            {/* Content Section */}
            <section style={{ padding: '80px 0' }}>
                <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>

                    {/* Acceptance of Terms */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            1. Acceptance of Terms
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            By accessing and using ATAM Connect ("the Platform"), you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to these terms, please do not use the Platform.
                        </p>
                    </div>

                    {/* Use of Service */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            2. Use of Service
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px', marginBottom: '16px' }}>
                            ATAM Connect provides a platform for discovering and connecting with Singapore's Indian Heritage and Arts events. You agree to use the service only for lawful purposes and in accordance with these Terms.
                        </p>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px', marginBottom: '12px' }}>
                            You agree not to use the Platform:
                        </p>
                        <ul style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px', paddingLeft: '24px' }}>
                            <li>In any way that violates any applicable law or regulation</li>
                            <li>To transmit any unauthorized advertising or promotional material</li>
                            <li>To impersonate or attempt to impersonate ATAM or any affiliated organization</li>
                            <li>To interfere with or disrupt the service or servers</li>
                        </ul>
                    </div>

                    {/* Event Information */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            3. Event Information
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            Event information displayed on the Platform is provided by event organizers and ATAM Arts Partners. While we strive to ensure accuracy, we do not guarantee the completeness, reliability, or accuracy of this information. Users are encouraged to verify event details directly with organizers before attending.
                        </p>
                    </div>

                    {/* External Links */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            4. External Links
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            The Platform may contain links to external websites for event registration, ticketing, or additional information. ATAM Connect is not responsible for the content, privacy policies, or practices of these third-party websites.
                        </p>
                    </div>

                    {/* Intellectual Property */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            5. Intellectual Property
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            The Platform and its original content, features, and functionality are owned by ATAM and are protected by international copyright, trademark, and other intellectual property laws. Organization logos and event images are property of their respective owners.
                        </p>
                    </div>

                    {/* Disclaimer of Warranties */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            6. Disclaimer of Warranties
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            The Platform is provided on an "as is" and "as available" basis without warranties of any kind, either express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.
                        </p>
                    </div>

                    {/* Limitation of Liability */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            7. Limitation of Liability
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            In no event shall ATAM Connect, its directors, employees, or partners be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Platform.
                        </p>
                    </div>

                    {/* Changes to Terms */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            8. Changes to Terms
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px' }}>
                            We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to the Platform. Your continued use of the Platform after changes constitutes acceptance of the modified terms.
                        </p>
                    </div>

                    {/* Contact Information */}
                    <div style={{ marginBottom: '48px' }}>
                        <h2 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '16px', color: 'var(--text-primary)' }}>
                            9. Contact Information
                        </h2>
                        <p style={{ color: 'var(--text-secondary)', lineHeight: '1.7', fontSize: '15px', marginBottom: '16px' }}>
                            If you have questions about these Terms and Conditions, please contact us at:
                        </p>
                        <div style={{
                            background: 'var(--bg-secondary)',
                            padding: '24px',
                            borderRadius: '12px',
                            border: '1px solid var(--border)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                                <Mail size={20} style={{ color: 'var(--text-primary)' }} />
                                <a href="mailto:admin@atam.sg" style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>
                                    admin@atam.sg
                                </a>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <Phone size={20} style={{ color: 'var(--text-primary)' }} />
                                <a href="tel:+6589327048" style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>
                                    +65 8932 7048
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            {/* Related Links */}
            <section style={{
                padding: '48px 0',
                background: 'var(--bg-secondary)',
                borderTop: '1px solid var(--border)'
            }}>
                <div className="container" style={{ maxWidth: '700px', margin: '0 auto', textAlign: 'center' }}>
                    <p style={{ color: 'var(--text-secondary)', marginBottom: '16px' }}>
                        Related Documents
                    </p>
                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Link to="/privacy" className="btn btn-ghost">
                            Privacy Policy
                        </Link>
                        <Link to="/about" className="btn btn-ghost">
                            About Us
                        </Link>
                        <Link to="/contact" className="btn btn-ghost">
                            Contact Us
                        </Link>
                    </div>
                </div>
            </section>
        </main>
    );
}
